import loadable from '@loadable/component';

import type { HotelsWithHighestGuestRatingProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelsWithHighestGuestRatingProps';

const CardRailWithInventoryCard = loadable(
  () => import('../CardRailWithInventoryCard/CardRailWithInventoryCard'),
);

const HotelsWithHighestGuestRating = (
  props: HotelsWithHighestGuestRatingProps,
) => <CardRailWithInventoryCard {...props} />;

export default HotelsWithHighestGuestRating;
